module.exports = __webpack_public_path__ + "img/CQ(3).6693c14d.webp";